import { useMemo } from "react";
import InformationsMetaTags from "@/components/MetaTags/InformationsMetaTags";
import InformationsList from "@/components/InformationsList";
import config from "@/lib/config";
import styles from "@/styles/Informations.module.scss";

export default function Informations() {
  const key = useMemo(() => {
    return config.information["vod"];
  }, []);

  return (
    <>
      <InformationsMetaTags />
      <div className={styles.container}>
        <InformationsList id={key} />
      </div>
    </>
  );
}
